module.exports = __webpack_public_path__ + "static/img/tab-ten.bbc81a72.png";